// extracted by mini-css-extract-plugin
module.exports = {"message":"TextReviewCard_message__PN2wu"};